export const userPermissionTypes = {
  FLAGGED: 'flagged',
  REVIEW: 'review',
  POINT_STATUS: 'point_status',
  COLLECTION: 'collection'
};
